/**
 * navigationState.js
 *
 * A lightweight store for passing non-URL data between route navigations.
 * Replaces Vue Router 3's non-URL `params` which were removed in Vue Router 4.
 *
 * Usage:
 *   import { setNavigationState, getNavigationState } from '@/router/navigationState';
 *
 *   // Before navigating:
 *   setNavigationState({ coverDetails: data, isFromLandingPage: true });
 *   this.$router.push({ name: 'target' });
 *
 *   // In receiving component (or route props function):
 *   const state = getNavigationState();  // returns data and clears it
 */

let _state = {};

export function setNavigationState(state) {
  _state = { ..._state, ...state };
}

export function getNavigationState() {
  const state = _state;
  _state = {};
  return state;
}

export function peekNavigationState() {
  return _state;
}
